import { Input } from "@jammable/ui-components/Forms";
import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import VoiceImage from "../VoiceImage";
import { useInfiniteQuery, useQuery } from "react-query";
import axios from "axios";
import millify from "millify";
import SearchVoiceItem from "./SearchVoiceItem";
import { Button, SecondaryButton, Switch } from "@jammable/ui-core";
import { Spinner } from "@jammable/ui-components/Loader";
import { BASE_URL } from "@jammable/clientapi";
import styles from "../../styles/Conversion.module.css";
import debounce from "lodash/debounce";
import SearchVoiceSection from "./SearchVoiceSection";
import { getAuth } from "firebase/auth";

const ChooseVoices = ({
  voices,
  addVoice,
  nextStage,
  selectCombo,
  originalModel,
  previousStage,
}) => {
  const limit = 10;
  const [search, setSearch] = useState("");
  const [mode, setMode] = useState("all");

  async function fetchModelsSortedByUses({ pageParam = 1 }) {
    const payload = {
      params: {
        search,
        limit,
        page: pageParam,
        sortOrder: "desc",
        sortBy: "usesLast24Hours",
        mode: mode,
      },
    };

    if (mode === "private" || mode === "saved") {
      const auth = getAuth();

      const token = await auth.currentUser.getIdToken();
      payload.headers = { Authorization: token };
    }

    const res = await axios.get(`/api/model`, payload);

    return res.data;
  }

  const models = useInfiniteQuery(
    ["all-models", search, mode],
    fetchModelsSortedByUses,
    {
      getNextPageParam: (lastPage) => {
        return lastPage.paging.hasMore ? lastPage.paging.page + 1 : undefined;
      },
    },
  );

  async function getDuetMatchingCombos() {
    const response = await axios.get(`/api/duets/getCommonCombos`, {
      params: {
        limit: 6,
        modelId: originalModel._id,
      },
    });
    return response.data.models;
  }

  const duetMatches = useQuery(["duet-combos", originalModel], () =>
    getDuetMatchingCombos({ modelIds: voices.map((voice) => voice._id) }),
  );

  const buttonSelectedStyle = `tw-bg-purple-700 tw-text-white`;
  const buttonCommonStyle = `tw-p-1 tw-text-sm tw-px-2.5  tw-rounded-full tw-cursor-pointer tw-text-gray-500 tw-font-black tw-transition-all`;
  return (
    <div className={styles["zoom-in"]}>
      <div className={`tw-font-bold tw-mb-2 tw-text-base tw-text-center `}>
        Add voices and make a collab! (Optional)
      </div>

      <div className="tw-flex tw-items-center tw-w-full tw-flex-col tw-justify-center tw-gap-3">
        <Input
          autoComplete="off"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          icon={<FaSearch />}
          placeholder="Search all voices..."
          className="tw-rounded-full tw-font-light tw-pl-14 "
          inputClassName="tw-rounded-l-full"
        />
        {search && (
          <div className="tw-flex tw-w-max tw-bg-gray-100 tw-p-1 tw-rounded-full tw-font-bold tw-gap-1 tw-items-center tw-mb-4">
            <div
              onClick={() => {
                setMode("all");
              }}
              className={`${mode === "all" ? buttonSelectedStyle : ""} ${buttonCommonStyle} `}
            >
              All
            </div>
            <div
              onClick={() => {
                setMode("private");
              }}
              className={`${mode === "private" ? buttonSelectedStyle : ""} ${buttonCommonStyle} tw-flex tw-gap-1`}
            >
              My Voices
            </div>
            <div
              onClick={() => {
                setMode("saved");
              }}
              className={`${mode === "saved" ? buttonSelectedStyle : ""} ${buttonCommonStyle} tw-flex tw-gap-1`}
            >
              Saved
            </div>
          </div>
        )}
      </div>

      {!search &&
        !(duetMatches?.data?.length === 0 && !duetMatches.isLoading) && (
          <SearchVoiceSection
            voices={duetMatches.data}
            subtitle={"COMMON COLLABS"}
            limit={6}
            isLoading={duetMatches.isLoading}
            addVoice={addVoice}
            selectedVoices={voices}
            isCombo={true}
            selectCombo={selectCombo}
          />
        )}

      {(search || duetMatches?.data?.length === 0) && (
        <SearchVoiceSection
          voices={models?.data?.pages[0]?.data}
          subtitle={search ? "SEARCH RESULTS" : "TRENDING"}
          limit={search ? 8 : 4}
          isLoading={models.isLoading}
          addVoice={addVoice}
          selectedVoices={voices}
          selectCombo={selectCombo}
        />
      )}

      <div className="md:tw-mt-10 tw-mt-4  tw-flex tw-gap-1 tw-items-end tw-justify-between ">
        <div className="tw-w-full tw-border tw-justify-between tw-flex tw-gap-0.5 tw-border-solid tw-border-gray-200 tw-rounded-full tw-items-center tw-pl-1">
          <div className="tw-flex">
            {voices?.map((voice, index) => {
              return (
                <div key={voice._id} className="tw-flex">
                  <VoiceImage
                    key={voice?._id}
                    model={voice}
                    size={42}
                    className="tw-rounded-full tw-border-2 tw-border-solid tw-border-white"
                    style={{
                      marginLeft: index === 0 ? 0 : -15,
                    }}
                  />
                </div>
              );
            })}
          </div>
          <Button
            onClick={() => {
              nextStage();
            }}
            className="tw-rounded-full tw-w-full tw-transition-width tw-h-12 "
          >
            <div className="tw-flex tw-flex-col">
              <div>Next Step</div>
              <div className="tw-uppercase tw-text-[10px] tw-text-white/50 tw-tracking-widest tw--mt-1">
                {voices.length === 6 ? "MAX" : voices.length} Voice
                {voices.length > 1 && "s"} Selected
              </div>
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChooseVoices;
